import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SectionHeading from "@/components/base/SectionHeading";
import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faqs";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://mangami2.github.io/" },
      { "@type": "ListItem", position: 2, name: "常见问题", item: "https://mangami2.github.io/faq" },
    ],
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  usePageMeta(
    "韩国妖精漫画角色图鉴常见问题｜萌娘属性与CP解读",
    "韩国妖精漫画角色图鉴FAQ：什么是韩国妖精漫画、萌娘属性与CP组合怎么解读、如何快速查找女主、图鉴资料是否准确等常见问题解答。",
    jsonLd
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <section className="bg-background-100/60">
          <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
            <nav aria-label="面包屑" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-600">首页</Link>
              <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
              <span className="text-foreground-700">常见问题</span>
            </nav>
            <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">常见问题</h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              关于韩国妖精漫画角色图鉴、萌娘属性、CP组合与使用方式，这里整理了读者最常问的问题。
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-4xl px-4 md:px-6 py-12 md:py-16">
          <SectionHeading
            eyebrow="FAQ"
            title="你关心的答案都在这里"
            desc="点击问题即可展开查看详细解答，如果还有疑问，欢迎通过『关于我们』页面的表单联系我们。"
          />
          <div className="divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-50">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? null : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3 text-sm font-semibold text-foreground-950 md:text-base">
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                      }`}>
                        {i + 1}
                      </span>
                      {f.q}
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-100 text-primary-600" : "bg-background-100 text-foreground-500"
                      }`}
                    >
                      <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                    </span>
                  </button>
                  {open && (
                    <div className="px-5 pb-5 pl-[3.75rem]">
                      <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}